import React from 'react';
import { Link } from 'react-router-dom';
function Footer() {
    return (
        <>
            <footer>
                <div className="top-line-theme"></div>
                <div className="row">
                    <div className=" col-lg-12">
                        <div className="row footer-right-links">
                            {/* <div className="col-lg-3">
                                <h6>Translation</h6>
                                <ul>
                                    <li className="drop-menu-item"><Link to="https://translation.aicte-india.org/translation-independent/">Online Document Translation Tool including Online Editor</Link></li>
                                    <li className="drop-menu-item"><Link to="https://anuvadini.aicte-india.org/govtofindiascheme/">Govt of India Schemes & Initiatives Voice Based Search (Chat GPT)</Link></li>
                                    <li className="drop-menu-item"><Link to="https://anuvadini.aicte-india.org/mkb100/">Mann ki baat (100th episode celebration) Citizen feedback Form</Link></li>
                                    <li className="drop-menu-item"><Link to="https://anuvadini.aicte-india.org/voiceform/">Voice Based Multilingual Form</Link></li>
                                    <li className="drop-menu-item"><Link to="https://anuvadini.aicte-india.org/dictation-tool/">Dictation Tool</Link></li>
                                    <li className="drop-menu-item"><Link to="https://anuvadini.aicte-india.org/lawdictionary/">Legal Glossary</Link></li>
                                    <li className="drop-menu-item"><Link to="https://translation.aicte-india.org/translation-independent/PmModiNationalInternshipPortal/">Video Translation</Link></li>
                                    <li className="drop-menu-item"><Link to="https://anuvadini.aicte-india.org/Bhasha-daan/">Bhasha Daan</Link></li>
                                    <li className="drop-menu-item"><Link to="https://translation.aicte-india.org/translation-independent/Text-Editor/">Chutki</Link></li>
                                </ul>
                            </div> */}
                            <div className="col-lg-6">
                                <h6>Voice</h6>
                                <ul className='d-flex justify-content-between voicediv'>
                                    <li className="drop-menu-item"><Link to="https://voice.aicte-india.org/">Voice: Speech to Speech & Video to Voice Translation, Speech Messenger</Link></li>
                                    <li className="drop-menu-item"><Link to="https://voice.aicte-india.org/">Voice: Text to Text, Image to Text Translation</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/ThreeDAudio">3D Audio</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/AutoPartner"> Auto Panner</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/BassBooster">Bass Booster</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/Equalizer">Equalizer</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/NoiseReducer">Noise Reducer</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/PitchShifter">Pitch Shifter</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/Reverb">Reverb</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/reverseAudio">Reverse Audio</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/stereoPanner">Stereo Panner</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/tempoChanger">Tempo Changer</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/trimmerCutter"> Trimmer / Cutter</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/vocalRemover">Vocal Remover</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/volumeChanger"> Volume Changer</Link></li>

                                </ul>
                            </div>
                            {/* <div className="col-lg-2">
                                <h6>Image</h6>
                                <ul>
                                    <li className="drop-menu-item"><Link to="/beta/PassportPhotoMaker">Passport Photo Maker</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/ImageBackgroundRemover">Image Background Remover</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/RemoveUnwantedObjects">Remove Unwanted Objects</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/FaceCutout">Face Cutout</Link></li>
                                </ul>
                                <br />
                                <h6>Video</h6>
                                <ul>
                                    <li className="drop-menu-item"><Link to="/beta/VideoBackgroundRemover">Video Background Remover</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/VideowithVoice">Video with Voice</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/TexttoVideo">Text to Video</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/AiVideoGenerator">AI Video Generator</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/AiSummary">AI Summary</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/Branding">Branding</Link></li>
                                </ul>
                            </div>

                            <div className="col-lg-2">
                                <h6>Meeting</h6>
                                <ul>
                                    <li className="drop-menu-item"><Link to="https://translation.aicte-india.org/translation-independent/transliterate/">Virtual Keyboard</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/ScreenRecording">Screen Recording</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/VideoRecording">Video Recording</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/MeetingCapture">Meeting Capture</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/MultiCameraRecording">Multi-Camera Recording</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/PhoneasWebcam">Phone as Webcam</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/Teleprompter">Teleprompter</Link></li>
                                    <li className="drop-menu-item"><Link to="/beta/RemoveCameraBackground">Remove Camera Background</Link></li>
                                </ul>
                                <br />
                                <h6>File</h6>
                                <ul>
                                    <li className="drop-menu-item"><Link to="killer-cv">Killer - CV</Link></li>
                                    <li className="drop-menu-item"><Link to="deep-search-document">Deep Search Document</Link></li>
                                </ul>
                            </div> */}
                            <div className="col-lg-2">
                                <h6>Other Links</h6>
                                <ul>
                                    <li><Link to="/beta/AboutUs" title="About Us">About Us</Link></li>
                                    <li><Link to="#!" title="Features">Features</Link></li>
                                    <li><Link to="#!" title="Sitemap">Sitemap</Link></li>
                                    <li><Link to="#!" title="Support">Support</Link></li>
                                    <li><Link to="#!" title="Blog">Blog</Link></li>
                                    <li><Link to="#!" title="FAQs">FAQs</Link></li>
                                    <li><Link to="#!" title="Account">Account</Link></li>
                                    <li><Link to="#!" title="Contact Us">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <hr />
                <br />
                <center>
                    <div className="footer-links">
                        <ul>
                            <li><Link to="/beta/PrivacyPolicy" title="Privacy Policy">Privacy Policy</Link></li>|
                            <li><Link to="/beta/TermOfUse" title="Term of Use">Term of Use</Link></li>|
                            <li><Link to="/beta/" title="Cookie Policy">Cookie Policy</Link></li>
                        </ul>
                    </div>
                </center><br />
                <center>© 2023 All rights reserved, AICTE<sup>®</sup></center>

            </footer>


        </>
    )
}

export default Footer;
